module.exports = __webpack_public_path__ + "static/img/message.c5cedf83.png";